import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import SmallAbout from "../components/SmallAbout";
import SmallCars from "../components/SmallCars";

const Home = () => {
  return (
    <div>
      <Navbar />
      <Hero title={"Home"} />
      <SmallAbout />
      <SmallCars />
      <Footer />
    </div>
  );
};

export default Home;
